export const sanitizeNumber = /[^0-9.]/;
